import { CustomCartAlert } from '@/components/modules/Application/components/_shared/components/ApplicationSummary/components/CartAlerts/components/CustomCartAlert';
import { Text } from '@/components/shared/components/Text';

export const PaymentMethodsAlert = ({ state, message }: { state: boolean; message: string }) => {
  if (state === true || !message) return null;
  return (
    <CustomCartAlert severity={'warning'} icon={'warning'}>
      <Text tId={message}></Text>
    </CustomCartAlert>
  );
};
